import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {
  // This is where it all starts
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('en');
  }
}
